import Container from "../../../../components/container";

export default function GreetingOccasionImagesSkeleton() {
  return (
    <div className="w-full flex flex-wrap gap-4 animate-pulse">
      {[...Array(10)].map((_, i) => (
        <Container key={i} className="card w-64 bg-base-100 shadow-xl relative">
          <div className="flex flex-col h-80">
            <div className="flex-1 flex items-center justify-center mb-12 contents">
              <div className="w-full h-full bg-gray-200" />
            </div>
            <div className="flex items-center justify-center bg-white h-12 p-1 gap-2 w-full absolute bottom-0 left-0 right-0">
              <div className="h-8 w-8 rounded-full bg-gray-200" />
              <div className="h-8 w-8 rounded-full bg-gray-200" />
              <div className="h-8 w-8 rounded-full bg-gray-200" />
            </div>
          </div>
        </Container>
      ))}
    </div>
  );
}